import React from 'react'

function PayNowOrder({numOrder, customerInfo}) {
    const getFirstLetterDNI = () => customerInfo.customer_doc.charAt(0);
    const getDNI = () => customerInfo?.customer_doc?.slice(1) ?? "";

    const getAddress = () => {
        const address = customerInfo?.customer_address;
        if (!address || address === false || address === undefined || address === null) {
            return 'N/D';
        }
        if (typeof address === 'string') {
            const addressLower = address.toLowerCase().trim();
            if (addressLower === '' || addressLower === 'false' || addressLower === 'undefined' || 
                addressLower.includes('false') || addressLower.includes('undefined')) {
                return 'N/D';
            }
        }
        return address;
    };
    
  return (
    <div>
        <div className="row g-3">
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-hashtag me-2"></i>
                        Número de Orden
                    </label>
                    <input 
                        type="text" 
                        className="form-control form-control-lg bg-light" 
                        disabled 
                        value={numOrder}
                        style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                    />
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-user me-2"></i>
                        Nombre Completo
                    </label>
                    <input 
                        type="text" 
                        className="form-control form-control-lg bg-light" 
                        disabled 
                        value={customerInfo.customer_name}
                        style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                    />
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-id-card me-2"></i>
                        Documento de Identidad
                    </label>
                    <div className="input-group">
                        <span className="input-group-text text-white fw-bold" style={{ border: 'none', borderRadius: '8px 0 0 8px', fontSize: '0.9rem', backgroundColor:'#014788'}}>
                            {getFirstLetterDNI()}
                        </span>
                        <input 
                            type="text" 
                            className="form-control form-control-lg bg-light" 
                            disabled 
                            value={getDNI()}
                            style={{ border: '1px solid #e9ecef', borderRadius: '0 8px 8px 0', fontSize: '0.9rem' }}
                        />
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-phone me-2"></i>
                        Teléfono
                    </label>
                    <input 
                        type="text" 
                        className="form-control form-control-lg bg-light" 
                        disabled 
                        value={customerInfo.customer_tlf}
                        style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                    />
                </div>
            </div>
            <div className="col-12">
                <div className="form-group">
                    <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-map-marker-alt me-2"></i>
                        Dirección
                    </label>
                    <input 
                        type="text" 
                        className="form-control form-control-lg bg-light" 
                        disabled 
                        value={getAddress()}
                        style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                    />
                </div>
            </div>
        </div>
    </div>
  )
}

export default PayNowOrder